import axios from 'axios';

const securitiesStore = {
  state: {
  },
  mutations: {
  },
  actions: {
    async getAllSecurities() {
      return axios
        .get(window.BASE_API.SECURITIES)
        .then(response => response.data).catch(error => Promise.reject(error));
    },

    async createSecurity(context, data) {
      return axios
        .post(window.BASE_API.SECURITIES, data)
        .then(response => response.data).catch(error => Promise.reject(error));
    },

    async updateSecurityByWKN(context, data) {
      return axios
        .put(`${window.BASE_API.SECURITIES}/${data.wkn}`, data)
        .then(response => response.data).catch(error => Promise.reject(error));
    },

    async deleteSecurityById(context, data) {
      return axios
        .delete(`${window.BASE_API.SECURITIES}/${data.id}`)
        .then(response => response.data).catch(error => Promise.reject(error));
    },
  },
};

export default securitiesStore;



// WEBPACK FOOTER //
// ./src/store/securities/securitiesStore.js